module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/business/business-category/category-group/category-group.component.css
// module id = ./src/app/components/business/business-category/category-group/category-group.component.css
// module chunks = main